import React from "react";
import { Grid, Divider } from "@mui/material";
import Assignments from "../components/ClassInfo/Assignments/Assignments.js";
import Grades from "../components/ClassInfo/Grades/Grades.js";
//import { useUser } from "../globals/UserContext";
import { useClass } from "../globals/ClassContext";
import { useState } from "react";

import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

//If we can pass the entire class object to the classInfo page we will not need to load redundent info
//Upcoming Assignments needs a list of all assignments
//Assignments needs a list of all assignments
//Grades needs the users grades for that class

export default function ClassInfo({ setPage }) {
  const classroom = useClass();

  const [expandedPanel, setExpandedPanel] = useState("panel1");

  const handleChange = (panel) => (event, newExpanded) => {
    setExpandedPanel(newExpanded ? panel : false);
  };

  return (
    <Grid
      container
      justifyContent="center"
      direction="column"
      sx={{ px: "15px", pt: "70px" }}
    >
      <Typography textAlign={"center"} fontSize={30}>
        {" "}
        {classroom.name}{" "}
      </Typography>
      <Grid
        container
        spacing={2}
        justifyContent="center"
        //alignItems = "center"
        divider={<Divider flexItem> </Divider>}
        sx={{ px: "15px", pt: "15px" }}
      >
        <Grid item xs={8}>
          <Typography fontSize={24} align="center" sx={{ pb: "15px" }}>
            Assignments
          </Typography>
          <div>
            <Accordion
              expanded={expandedPanel === "panel1"}
              onChange={handleChange("panel1")}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
                fontSize={24}
                align="center"
                //sx={{ pb: "15px" }}
              >
                <Typography>Upcoming Assignments</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Assignments
                  setPage={setPage}
                  filter={"upcomming"}
                  key={classroom._id}
                />
              </AccordionDetails>
            </Accordion>
            <Accordion
              expanded={expandedPanel === "panel2"}
              onChange={handleChange("panel2")}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel2a-content"
                id="panel2a-header"
                fontSize={24}
                align="center"
                //sx={{ pb: "15px" }}
              >
                <Typography>Future Assignments</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Assignments
                  setPage={setPage}
                  filter={"future"}
                  key={classroom._id + " future"}
                />
              </AccordionDetails>
            </Accordion>
            <Accordion
              expanded={expandedPanel === "panel3"}
              onChange={handleChange("panel3")}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel3a-content"
                id="panel3a-header"
                fontSize={24}
                align="center"
                //sx={{ pb: "15px" }}
              >
                <Typography>Past Assignments</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Assignments
                  setPage={setPage}
                  filter={"past"}
                  key={classroom._id + " past"}
                />
              </AccordionDetails>
            </Accordion>
            <Accordion
              expanded={expandedPanel === "panel4"}
              onChange={handleChange("panel4")}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel4a-content"
                id="panel4a-header"
                fontSize={24}
                align="center"
                //sx={{ pb: "15px" }}
              >
                <Typography>All Assignements</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Assignments
                  setPage={setPage}
                  filter={"all"}
                  key={classroom._id + " all"}
                />
              </AccordionDetails>
            </Accordion>
          </div>
        </Grid>
        <Grid item xs={4}>
          <Typography fontSize={24} align="center" sx={{ pb: "15px" }}>
            Grades
          </Typography>
          <Grades setPage={setPage} />
        </Grid>
      </Grid>
    </Grid>
  );
}
